import CloseIcon from '@mui/icons-material/Close';
import {
    IconButton,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useCallback } from 'react';
import { convertNumber } from '../../components/fields';
import { useIdentityContext } from '../../components/identity';
import { formatter } from '../../utils/Constants/ConstantData';
export const BonusEarningModal = (props) => {
    const {
        isOpen = false,
        onClose,
        isOverage,
        bonusDetailData
    } = props;
    const identity = useIdentityContext();

    const handleClick = useCallback(e => {
        e.stopPropagation();
    }, []);

    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
            aria-labelledby="bonus-earning-title"
            className={`${isOverage ? 'bonus-earning-modal overage-modal':'bonus-earning-modal'}`}
        >
        <DialogTitle id="alert-dialog-title">
            <Stack flexDirection={'row'} justifyContent={'space-between'}>
            Earnings Details
                <IconButton
                    sx={{top:-2,paddingLeft:2}}
                    color="primary"
                    aria-label="void modal"
                    onClick={onClose}
                >
                    <CloseIcon />
                </IconButton>
            </Stack>
            </DialogTitle>
            <DialogContent>
            <TableContainer className="bonuses-table-paper">
           <Table aria-label="Bonuses Worker table" className='RaDatagrid-table'>
               <TableHead>
                   <TableRow>
                       <TableCell>Payroll Period</TableCell>
                       <TableCell>Hours</TableCell>
                      {!isOverage && <TableCell align="right">Bonus</TableCell>}
                       {(!identity?.company?.remove_ot_diff && !isOverage) && <TableCell align="right">OT Diff</TableCell>}
                       <TableCell align="right">Total</TableCell>
                   </TableRow>
               </TableHead>
               <TableBody>
                   <>
                   {
                       isOverage ? bonusDetailData.map(item=>{
                        return(<TableRow>
                         <TableCell>{item.period_id_obj.name}</TableCell>
                         <TableCell>{convertNumber(item.hours,identity)}</TableCell>
                         <TableCell>-{formatter.format(item.deficit_amount)}</TableCell>
                     </TableRow>)
                    }):bonusDetailData.map(item=>{
                        return(<TableRow>
                         <TableCell>{item.payroll_id_obj.name}</TableCell>
                         <TableCell>{convertNumber(item.performance_hours,identity)}</TableCell>
                         <TableCell>{formatter.format(item.performance_bonus)}</TableCell>
                         {!identity?.company?.remove_ot_diff && <TableCell>{formatter.format(item.net_bonus_ot_diff_amt)}</TableCell>}
                         <TableCell>{formatter.format(item.performance_bonus + item.net_bonus_ot_diff_amt)}</TableCell>
                     </TableRow>)
                    })
                   }
                   </>

           {}
               </TableBody>
               </Table>
               </TableContainer>
            </DialogContent>
        </Dialog>
    );
};

